import React from 'react'
import PayoutsReviewTab from './Tab/PayoutsReviewTab'

export default function PayoutsReviewCard() {
  return (
    <div className="relative flex grow flex-col overflow-hidden rounded-md bg-white">
      <PayoutsReviewTab />
    </div>
  )
}
